import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const constants = {
	ACCEPT: 'Accept',
	ACTIVE: 'active',
	ACTIVE_CONFIRM: 8,
	ALL: 'ALL',
	ALL_CONNECTORS_POOL_NAME: 'All Connectors',
	ALMOST_FULL: 'Almost Full',
	ALTERATION: 'alteration',
	Ambassador: 5,
	APPLICATION_ACCEPTED: 'Accepted',
	APPLIED: 'Applied',
	APPROVE_EVENT: 1,
	APPROVED: 'approved',
	APPROVED_QR_CHECKOUT: 'approved_qr_checkout',
	APPROVED_SELF: 'approved_self',
	AUTOMATION_APPROVED: 'automation_approved',
	backfill: 18,
	BEAT_ADMIN_USER: 'Beat Admin User',
	BONUS_APPROVED: 'Approved',
	BONUS_APPROVED_ID: 1,
	BONUS_INELIGIBLE: 'Ineligible',
	BONUS_INELIGIBLE_ID: 3,
	BONUS_PAID: 'Paid',
	BONUS_PAID_ID: 2,
	BONUS_PROCESSED: 'Processed',
	BONUS_PROCESSED_ID: 4,
	BONUS_STATCASH_PROCESSED_ID: 1,
	BREAK: 'break',
	BREAK_NOT_TAKEN: 'notTaken',
	BREAK_TAKEN: 'taken',
	CANCELED: 'Canceled',
	CHECKIN_MSG_TYPE: 'checkin',
	checkin_signoff: 2,
	CHECKINADMIN: 'admin_checkin',
	CHECKINAPPROVA: 'checkin_sup',
	CHECKOUT: 'checkout',
	cico: 1,
	COMPLETED: 'Completed',
	Date: 6,
	day_start_time: dayjs.utc('04:00:00', 'HH:mm:ss'),
	Days: 1,
	DEFAULT: 'default',
	defaultDistanceValue: '30',
	Distance: 'DISTANCE',
	DOCUMENT: 'document',
	EDIT_SUSPEND_CONFIRM: 10,
	EDIT_SUSPEND_EVENT: 9,
	EDITTIMESHEET: 'save_timesheet',
	ELIGIBLE: 'eligible',
	// This keyword is used to set back previous status of timesheet
	est_timezone: 'America/New_York',
	ExcludeWaitlist: 7,
	Expired: 2,
	ExpiredStatus: 'Expired',
	ExpiringSoon: 3,
	ExpiringSoonStatus: 'Expiring Soon',
	FromDate: 'FromDate',
	FROMSHIFTDETAIL: 'fromShiftDetail',
	FROMSHIFTLIST: 'fromShiftList',
	FULL: 'Full',
	Gold: 3,
	INACTIVE: 'inactive',
	INACTIVE_EVENT: 7,
	INELIGIBLE: 'ineligible',
	INMEDIATION: 'inmediation',
	instantAccept: 'Instant Accept',
	instantAcceptGlobal: 'Instant Accept - Global',
	instantAcceptNurse: 'Instant Accept - Nurse',
	ISRECOMMENDEDSHIFT: 'isRecommendedShift',
	ISRECOMMENDEDSHIFTDETAIL: 'isRecommendedShiftDetail',
	ISRECOMMENDEDSHIFTLIST: 'isRecommendedShiftList',
	LD_AUTUMN_LAKE_CICO_INTEGRATION: 'autumn-lake-cico-integration',
	LD_SMART_IA_FLAG: 'smart-ia',
	Location: 3,
	MEDIATION: 'mediation_req',
	Member: 1,
	Miles: 5,
	MULTI_FULFILLMENT: 'multi-fulfillment',
	ndp: 7,
	night_start_time: dayjs.utc('18:00:00', 'HH:mm:ss'),
	NO_CALL_NO_SHOW: 'No Call No Show',
	NOT_CHECKED_IN: 'not checked in',
	NOT_REGISTER: 'notregister',
	NOT_RETURN_TO_FACILITY: 'not_return_to_facility',
	ONGOING: 'ongoing',
	ONGOINGSHIFT: 'Ongoing',
	Open: 'Open',
	OPEN: 'Open',
	OTHER: 'Other',
	OTHER_REQUIRED: 'Other (text input, required)',
	OVERDUECHECKIN: 'Overdue Checkin',
	OVERDUECHECKOUT: 'Overdue Checkout',
	PAID: 'paid',
	PAYPLUS: 'Pay+™',
	PENDING: 'pending',
	PENDING_PAYROLL_RUN: 'pending_payroll_run',
	PENDING_QR_CHECKIN: 'pending_qr_checkin',
	PENDING_QR_CHECKOUT: 'pending_qr_checkout',
	pincode_checkin_signoff: 8,
	pincode_checkout_signoff: 6,
	Platinum: 4,
	PREFERRED_CONNECTORS_POOL: 2,
	PREFERRED_CONNECTORS_POOL_NAME: 'Preferred Connectors',
	PROCESSED: 'processed',
	PROCESSED_PAYROLL_RUN: 'processed_payroll_run',
	QR_CHECK_IN: 'qr_check_in',
	QR_CHECK_IN_WO_SUP: 'qr_check_in_wo_sup',
	RATE_INCREASE_SUPERVISOR: 'Rate Increase - Supervisor',
	RecommendedShifts: 8,
	REJECT: 'Decline',
	REJECT_EVENT: 2,
	REJECTED: 'rejected',
	REMEDIATION: 'remediation',
	REMEDIATION_EVENT: 11,
	SCOPE_ALERT_READ: 'alert:read',
	SCOPE_BONUS_BILLABLE_WRITE: 'bonus.billable:write',
	SCOPE_BONUS_OVERWRITE_ORG_SHIFT_LEVEL_BONUS_WRITE: 'bonus:overwrite_org_shift_level_bonus:write',
	SCOPE_BONUS_WRITE: 'bonus:write',
	SCOPE_CLINICIAN_SKILLS_READ: 'clinician.skills:read',
	SCOPE_CLINICIAN_SKILLS_WRITE: 'clinician.skills:write',
	SCOPE_HELP_READ: 'help:read',
	SCOPE_NOTIFICATION_READ: 'notification:read',
	SCOPE_NURSE_READ: 'nurse:read',
	SCOPE_ORG_ACQUISITION: 'org.acquisition',
	SCOPE_ORG_INFO_WRITE: 'org.info:write',
	SCOPE_ORG_LOC_REQUIREMENTS_READ: 'org.loc.requirements:read',
	SCOPE_ORG_LOC_REQUIREMENTS_WRITE: 'org.loc.requirements:write',
	SCOPE_ORG_SETTINGS_READ: 'org.settings:read',
	SCOPE_ORG_SHIFT_LEVEL_BONUS_SETTING_WRITE: 'org.shift_level_bonus_setting:write',
	SCOPE_RELEASE_TOGGLES_ADMIN_READ: 'release.toggles.admin:read',
	SCOPE_RELEASE_TOGGLES_ADMIN_WRITE: 'release.toggles.admin:write',
	SCOPE_REQUIREMENTS_REQUEST_APPROVE: 'requirements.request:approve',
	SCOPE_REQUIREMENTS_REQUEST_UPDATE: 'requirements.request:update',
	SCOPE_REQUIREMENTS_TAB_ADMIN_READ: 'requirements.admin:read',
	SCOPE_REQUIREMENTS_TAB_ADMIN_WRITE: 'requirements.admin:write',
	SCOPE_SEARCH_READ: 'search:read',
	SCOPE_SHIFT_APPLICANT_READ: 'shift_applicant:read',
	SCOPE_SHIFT_READ: 'shift:read',
	SCOPE_SHIFT_WRITE: 'shift:write',
	SCOPE_TIMESHEET_COMMENT: 'timesheet.comment',
	SCOPE_TIMESHEET_COMPONENT: 'timesheet.component',
	SCOPE_TIMESHEET_EDIT: 'timesheet:edit',
	SCOPE_TIMESHEET_READ: 'timesheet:read',
	SCOPE_USER_ACCESS_LEVEL_READ: 'info.access_level:read',
	SCOPE_USER_ACCESS_LEVEL_WRITE: 'user.access_level:write',
	SCOPE_USER_ADMIN_WRITE: 'user.admin:write',
	SCOPE_USER_BEAT_ADMIN_WRITE: 'user.beat_admin:write',
	SCOPE_USER_NURSE_WRITE: 'user.nurse:write',
	SCOPE_USER_SUPERVISOR_QR: 'user.supervisor.qr',
	SCOPE_USER_SUPERVISOR_WRITE: 'user.supervisor:write',
	SHIFT_ACCEPTED: 'Accepted',
	SHIFT_CANCELED: 'Canceled',
	SHIFT_CLOSED: 'Closed',
	SHIFT_FILLED_NO_LONGER_NEEDED: 'Shift filled/nurse no longer needed',
	SHIFT_MANAGER_GLOBAL: 'Shift Manager - Global',
	SHIFT_MANAGER_SUPERVISOR: 'Shift Manager - Supervisor',
	Silver: 2,
	SINGUP_URL: 'https://www.fountain.com/connectrn/apply/united-states-connectrn?preview=true',
	SOME: 'SOME',
	Specialties: 4,
	STATCASH_LABEL: 'STATcash',
	STATCASH_PROCESS_METHOD: 'statcash',
	STATCASH_PROCESS_VALUE: 1,
	STATUS: 'status',
	SUPERVISOR_HELP_JUICE_URL: 'https://connectrn.helpjuice.com/facility/secrets/nF8aIp3glONc2eIl6NXInw',
	SUPERVISOR_HELP_PAGE_HEADING_1: 'Get support and resources to the most common questions',
	SUPERVISOR_HELP_PAGE_HEADING_2: 'Need more help',
	SUPERVISOR_HELP_PAGE_PARA_1:
		'A comprehensive knowledge hub for your partnership with connectRN from how to use the platform to accounting and billing inquiries.',
	SUPERVISOR_HELP_PAGE_PARA_2: 'Tell us what’s going on and we’ll get you to the right resource.',
	SUPERVISOR_HELP_PAGE_TOP_BUTTON: 'Find your answers',
	SUPERVISOR_HELP_PAGE_TOP_BUTTON_2: 'Submit an issue',
	// This keyword is defined as sorting open shift list by status is handled FE side.
	SUPERVISOR_UNAVAILABLE: 'supervisor_unavailable',
	SUPERVISOR_UNAVAILABLE_CHECKIN: 'supervisor_unavailable_checkin',
	SUSPEND: 'suspend',
	SUSPEND_CONFIRM: 4,
	SUSPEND_TIME: 3,
	TAB_ACCEPTED: 'Accepted',
	TAB_APPLIED: 'Applied',
	TAB_COMPLETED: 'Completed',
	TAB_OPEN: 'Open',
	TEXT_OPTION_ALL: 'All',
	theBeatUser: 'The Beat User',
	Time: 2,
	ToDate: 'ToDate',
	UNIT_PROCESS_METHOD: 'unit',
	UNIT_PROCESS_VALUE: 3,
	UNREGISTERED: 'unregistered',
	UNSUSPEND_EVENT: 6,
	WEEKLY_LABEL: 'Weekly Pay',
	WEEKLY_PROCESS_METHOD: 'weekly',
	WEEKLY_PROCESS_VALUE: 2,
	WEEKLY_TEXT: 'Weekly pay',
	WITHDRAW: 'Withdraw',
	Zipcode: 'ZIP CODE'
};

export default constants;
